import HBIcon from "@/components/HBIcon";
import HBMessage from "@/components/HBMessage";
import HBModal from "@/components/HBModal";
import ModalWrap from "@/components/HBModal/ModalWrap";
import JobSelect from "@/components/JobSelect";
import useAppStore from "@/context/store";
import { setSettings } from "@/services";
import { useMemoizedFn } from "ahooks";
import { Button, Form } from "antd";
import classNames from "classnames";
import { useState } from "react";
import AreaSelect from "./AreaSelect";
import styles from "./index.module.less";

/**
 *
 * @param {import("antd").ModalProps} param
 * @returns
 */
function DialogRaw({ onOk, ...props }) {
  const [submitState, setSubmitState] = useState(true);
  const onFormChange = useMemoizedFn((values, all) => {
    if (all.job && all.areas) {
      setSubmitState(false);
    } else {
      setSubmitState(true);
    }
  });

  const onFinish = useMemoizedFn(async (values) => {
    const res = await setSettings({
      // 职业
      profile: {
        job: values.job?.name,
      },
      job_id: values.job?.id,
      // 领域
      job_ids: values.areas,
    });

    if (!res.err) {
      HBMessage.success("设置成功");
      useAppStore.getState().refreshUser();
      onOk();
    }
  });

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <HBModal
      {...props}
      footer={null}
      width={740}
      wrapClassName={styles.dialog}
      maskClosable={false}
      closeIcon={
        <HBIcon
          type="ic_close"
          data-gd-click="button_click"
          data-button-name="关闭新人引导弹框"
          data-content-source="新人引导弹框"
        />
      }
    >
      <div className={styles.header}>
        <div className={styles.title}>注册成功，欢迎来到花瓣</div>
        <div className={styles.subTitle}>
          让花瓣更加了解你，为你推荐更多优质灵感图片
        </div>
      </div>
      <Form
        layout="vertical"
        onValuesChange={onFormChange}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          className={classNames([styles.item, styles.last])}
          name="job"
          label="你所从事的职业"
        >
          <JobSelect
            placeholder="我的职业"
            inputCol={24}
            selectCol={24}
            inputPlaceholder="请输入职业"
            noWrapper
          />
        </Form.Item>
        <Form.Item
          label="你感兴趣的领域（可多选）"
          className={classNames([styles.item, styles.last])}
          name="areas"
        >
          <AreaSelect></AreaSelect>
        </Form.Item>

        <Form.Item className={styles.submit}>
          <Button
            type="primary"
            htmlType="submit"
            disabled={submitState}
            data-gd-click="button_click"
            data-button-name="我选好了"
            data-content-source="新人引导弹框"
          >
            我选好了
          </Button>
        </Form.Item>
      </Form>
    </HBModal>
  );
}

const GuideDialog = ModalWrap(DialogRaw);

export default GuideDialog;
